import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import httpClient from './httpClient';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Del = (endpoint) => {
  const queryClient = useQueryClient();

  const deleteQueryFunction = (param) => new Promise((resolve, reject) => {
    httpClient.delete(`${endpoint}/${param}/`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });

  return useMutation({
    mutationFn: deleteQueryFunction,
    mutationKey: [endpoint],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [endpoint] });
    },
  });
};

export default Del;
